module.exports = __webpack_public_path__ + "static/media/error.fd06db78.gif";